import { QuoteRequestDTO, QuoteRequestStatus } from '@luminovo/api-contracts';
import { StatusChip } from '@luminovo/design-system';

import { formatQuoteRequestStatus } from '../../formatters/formatQuoteRequestStatus';

export function QuoteRequestStatusChip({
    status,
    perspective = 'sender',
}: Pick<QuoteRequestDTO, 'status'> & { perspective?: 'sender' | 'receiver' }) {
    return (
        <StatusChip
            color={getQuoteRequestStatusColor(status)}
            label={formatQuoteRequestStatus(status, { perspective })}
        />
    );
}

export function getQuoteRequestStatusColor(status: QuoteRequestStatus) {
    switch (status) {
        case QuoteRequestStatus.NotSent:
            return 'neutral';
        case QuoteRequestStatus.Sent:
            return 'blue';
        case QuoteRequestStatus.Overdue:
            return 'red';
        case QuoteRequestStatus.Discarded:
            return 'yellow';
        case QuoteRequestStatus.Received:
            return 'green';
    }
}
